import type { WFLocationDTO } from '@ui/shared/util-api';
import { MapItem } from '@ui/shared/util-map';

export class EconomicDevelopmentMapItem extends MapItem {
    public readonly description: string;
    public readonly imagePath: string;
    public readonly thumbnailPath: string;
    public readonly categoryLabel: string;
    public readonly district: string;
    public readonly industries: Array<string>;
    public readonly weblink: string;
    public readonly closestPublicTransport: { name: string; link: string } | undefined;

    constructor(mapItem: WFLocationDTO) {
        super(mapItem);

        this.mapArea = mapItem.area?.coordinates;

        this.description = mapItem.description;

        this.iconPath = mapItem.icon ?? '';
        this.imagePath = mapItem.image?.thumbs?.detail ?? mapItem.image?.image ?? '';
        this.thumbnailPath = mapItem.image?.thumbs?.preview ?? this.imagePath;

        this.categoryLabel = mapItem.location_type?.name ?? '';
        this.iconLabel = this.categoryLabel ? `Kategorie: ${ this.categoryLabel }` : '';
        this.industries = mapItem.industries.map(industry => industry.name);
        this.district = mapItem.district?.name ?? '';

        this.weblink = mapItem.further_info_link ?? '';
        this.closestPublicTransport = mapItem.closest_public_transport_station ?? undefined;
    }
}
